// extracted by mini-css-extract-plugin
export default {"section":"DDAul","header":"JrZ4t","headerText":"HAiXc","inner":"H3aol","files":"GI7RH","file":"GK8Ij"};